import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { PureTable } from '../../../../../common/ui/pure-table/pure-table'
import { ObjectItem } from '../../../../../entities/objects/types/object.types'
import { useWorkspaceStore } from '../../../../../entities/workflow/stores/workspace.store'
import { Checklist, MilestoneItem } from '../../../../../entities/workflow/types/workflow.types'
import { getWorkspaceTableColumns } from '../../helpers/get-workspace-table-columns'

type WorkspaceTableProps = {
  objects: ObjectItem[]
  milestones: MilestoneItem[]
  checklists: Checklist[]
}

export const WorkspaceTable = ({ objects, milestones, checklists }: WorkspaceTableProps) => {
  const { t } = useTranslation()
  const { checkedMilestones, setSelectedMilestone, setSelectedObject, workspaceConfiguration } = useWorkspaceStore()
  const columns = useMemo(() => {
    const checklistMap = new Map(checklists.map((c) => [`${c.milestoneId}-${c.objectId}`, c]))

    return getWorkspaceTableColumns(
      milestones,
      checklistMap,
      workspaceConfiguration.workMode,
      t,
      checkedMilestones,
      setSelectedMilestone,
      setSelectedObject,
      workspaceConfiguration.tableMode,
    ) as any
  }, [objects, milestones, checklists, workspaceConfiguration, checkedMilestones])

  return (
    <PureTable
      columns={columns}
      dataSource={objects}
      rowKey="id"
      bordered
    />
  )
}
